namespace $.$$ {

	$mol_style_define( $shm_wordstat_region_select, {
		flex: {
			direction: 'column',
		},
		// gap: $mol_gap.text,

		Title: {
			flex: {
				direction: 'column',
			},
			minWidth: 0,
			maxWidth: '100%',
			font: {
				weight: 'bold',
				size: '16px',
			},
		},

		Title_line: {
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
			minWidth: 0,
		},

		Label: {
			minWidth: 0,
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Select_all: {
			flex: {
				shrink: 0,
			},
		},

		Summary: {
			color: $mol_theme.shade,
			font: {
				weight: 'normal',
				size: '13px',
			},
			minWidth: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},

		Content: {
			flex: {
				direction: 'column',
			},
			minWidth: 0,
		},

		Search: {
			minWidth: 0,
		},

		Presets: {
			minWidth: 0,
			gap: 0,
			flex: {
				direction: 'column',
			},
		},

		Preset_actions: {
			minWidth: 0,
			gap: 0,
			flex: {
				direction: 'row',
			},
		},

		Preset_reset: {
			minWidth: 0,
		},

		Preset_collapse: {
			minWidth: 0,
		},

		Preset_districts: {
			minWidth: 0,
		},

		Preset_areas: {
			minWidth: 0,
		},

		Tree: {
			flex: {
				direction: 'column',
			},
			minWidth: 0,
		},

		Node: {
			flex: {
				direction: 'column',
			},
			minWidth: 0,
		},

		Row: {
			display: 'grid',
			gridTemplateColumns: '1.5rem minmax(0, 1fr)',
			minHeight: '1.75rem',
			alignItems: 'center',
			minWidth: 0,
		},

		Row_expand: {
			justifyContent: 'center',
			minWidth: '1.5rem',
			width: '1.5rem',
		},

		Row_check: {
			justifyContent: 'flex-start',
			minWidth: 0,
			flex: {
				grow: 1,
				shrink: 1,
			},
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			Title: {
				minWidth: 0,
				whiteSpace: 'normal',
				overflowWrap: 'anywhere',
				wordBreak: 'break-word',
			},
		},

		Row_content: {
			position: 'relative',
			minWidth: 0,
			alignItems: 'center',
			flex: {
				grow: 1,
				shrink: 1,
			},
			':hover': {
				['Row_only' as '$mol_view']: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
		},

		Row_only: {
			opacity: 0,
			pointerEvents: 'none',
			position: 'absolute',
			right: 0,
			height: '100%',
			minHeight: 0,
			minWidth: 0,
			zIndex: $mol_layer.hover,
			background: {
				color: $mol_theme.back,
			},
			padding: {
				left: $mol_style_unit.px( 6 ),
				right: $mol_style_unit.px( 6 ),
				top: $mol_style_unit.px( 2 ),
				bottom: $mol_style_unit.px( 2 ),
			},
			font: {
				size: $mol_style_unit.px( 12 ),
			},
		},

		Row_collapse: {
			margin: {
				left: 'auto',
			},
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Row_label: {
			minWidth: 0,
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			color: $mol_theme.shade,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},

		Children: {
			flex: {
				direction: 'column',
			},
			minWidth: 0,
			margin: {
				left: $mol_style_unit.rem( .75 ),
			},
			padding: {
				left: $mol_style_unit.rem( .75 ),
			},
			box: {
				shadow: [{
					inset: true,
					x: $mol_style_unit.px( 1 ),
					y: 0,
					blur: 0,
					spread: 0,
					color: $mol_theme.line,
				}],
			},
		},
	} )

}
